/**
 * Initialize a Swiper carousel with common functionality
 * @param {Object} options - Configuration options
 * @param {string} options.sectionId - Unique section identifier
 * @param {string} options.containerClass - CSS class for the swiper container
 * @param {Object} options.swiperConfig - Swiper configuration object
 * @param {boolean} options.enableCaptions - Whether to enable caption functionality (default: false)
 * @param {boolean} options.enableCursorNav - Whether to enable cursor navigation (default: true)
 * @returns {Object} Swiper instance
 */
function initSwiper(options) {
  const {
    sectionId,
    containerClass,
    swiperConfig = {},
    enableCaptions = false,
    enableCursorNav = true
  } = options;

  const swiperEl = document.querySelector(`.${containerClass}-${sectionId} .swiper`);
  const swiperWrapperEl = document.querySelector(`.${containerClass}-${sectionId} .swiper-wrapper`);

  if (!swiperEl) {
    console.warn(`Swiper element not found for selector: .${containerClass}-${sectionId} .swiper`);
    return null;
  }

  /* Update caption on slide change */
  const updateCaption = (swiper) => {
    if (!enableCaptions) return;

    const captions = document.querySelectorAll(`.${containerClass}-${sectionId} .Caption`);
    const index = swiper.realIndex;
    const activeCaption = captions[index];

    captions.forEach((caption) => caption.classList.remove('active'));
    if (activeCaption) {
      activeCaption.classList.add('active');
    }
  };

  /* Merge default config with provided config */
  const finalConfig = {
    ...swiperConfig,
    on: {
      init: function () {
        updateCaption(this);
        if (swiperConfig.on?.init) {
          swiperConfig.on.init.call(this);
        }
      },
      slideChangeTransitionEnd: function () {
        updateCaption(this);
        if (swiperConfig.on?.slideChangeTransitionEnd) {
          swiperConfig.on.slideChangeTransitionEnd.call(this);
        }
      },
      ...(swiperConfig.on || {})
    }
  };

  /* Init. carousel */
  const swiper = new Swiper(swiperEl, finalConfig);

  /* Handle cursor navigation */
  if (enableCursorNav && swiperWrapperEl) {
    swiperWrapperEl.addEventListener('mousemove', function(e) {
      const elWidth = this.getBoundingClientRect().width;
      const halfWidth = elWidth / 2;
      const cursorXPos = e.offsetX;

      if (cursorXPos < halfWidth) {
        this.classList.add('chevron-left');
        this.classList.remove('chevron-right');
      } else {
        this.classList.add('chevron-right');
        this.classList.remove('chevron-left');
      }
    });

    swiperWrapperEl.addEventListener('mouseleave', function() {
      this.classList.remove('chevron-left');
      this.classList.remove('chevron-right');
    });

    swiperWrapperEl.addEventListener('click', function(e) {
      const elWidth = this.getBoundingClientRect().width;
      const halfWidth = elWidth / 2;
      const cursorXPos = e.offsetX;

      if (cursorXPos < halfWidth) {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    });
  }

  return swiper;
}
